"use strict";

import $ from "jquery";
window.$ = window.jQuery = $;
import "slick-carousel";

export class Hero {
  constructor() {
    console.log("Hero module");

    (function($) {
      // Use $ as usual here, e.g.:
      $(".js__slick-carousel-hero").slick({
        infinite: true,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        autoplay: true
      });

      $(".js__btn-next--hero").on("click", function(e) {
        e.preventDefault();
        $(".js__slick-carousel-hero").slick("slickNext");
      });
      
    })(jQuery);
  }
}
